import { fileAdCvdQryFunction, fileAdCvdWithRequestId, setManualResponse, getRecentQry} from '../apiCalls';
import store from '../store';

const initialState = {
}

export const RecentQryReducer = (state = initialState, action) => {
    switch (action.type) {
        
        case 'GET_RECENT_QRY': {
            getRecentQry(action.brokerId, action.page)
            return state;
        }
        case 'SET_RECENT_QRY': {
            let newState = Object.assign({}, state);
            newState.recentQryList = action.recentQryList;
            return Object.assign({}, state, { ...newState });
        }
        case "SET_PAGE": {
            return Object.assign({}, state, { page: action.page});
          }
        default:
        return state
    }
}